export class DrawWcPlayoffRequest {
    season: number;
    stage: number;
    md: number;
}